import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';

import { useUpdateCompensationInfoHiringMutation } from 'services/talento';
import { regexPatterns } from 'utils/helpers/dictionaries';

import { IAdminPanelForm } from './AdminPanelForm.schema';


export function useLaboralSubmit() {
  const { getValues, setValue } = useFormContext<IAdminPanelForm>();
  const { email } = useParams();
  const [updateCompensationInfoHiring] = useUpdateCompensationInfoHiringMutation();

  function removeDots(value: string): string {
    return value.replace(regexPatterns.removePoints, '');
  }

  async function submitData() {
    const employmentSection = getValues('organizationalInformation');
    const compensationSection = getValues('compensationInformation');
    const role = getValues('role');
    const position = getValues('position');
    const contractType = getValues('contractType');
    const formattedEmploymentSection = {
      ...employmentSection,
      aprStartDate:
        contractType === 'Aprendizaje Etapa Lectiva-COL' ? employmentSection.aprStartDate : null,
    };

    const response = await updateCompensationInfoHiring({
      email: email ?? '',
      role,
      ...formattedEmploymentSection,
      contractType,
      position,
      compensationInformation: compensationSection.map((compensation) => ({
        ...compensation,
        salaryBase: parseFloat(removeDots(compensation.salaryBase ? compensation.salaryBase : '')),
      })),
    }).unwrap();

    setValue('compensationInformation', response.data.compensationInformation);

    if (response.data.organizationalInformation) {
      setValue('organizationalInformation', response.data.organizationalInformation);
    }
  }

  return submitData;
}
